module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "author"
  }, [_vm._v("2")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('span', [_vm._v("Wenn du")]), _vm._v(" mir befiehlst zu\nsingen,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nscheint mir das Herz vor Stolz brechen"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nzu wollen; ich schau in dein Antlitz, und"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nTränen kommen mir in das Auge. All das,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nwas hart und mißtönig ist mir im Leben,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nzerschmilzt in eine süße Harmonie – und"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nmeine Anbetung breitet die Schwingen"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ngleich einem frohen Vogel im Fluge über die See.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Ich weiß, mein Singen macht dir Freude,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nich weiß, nur als Sänger werde ich vor"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ndich gelassen.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Ich rühre mit dem Saume der\nweitausgebreiteten"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nSchwinge des Sangs deine"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nFüße, die nie zu erreichen ich streben"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nkönnte.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Trunken von Freude des Singens vergeß"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nich mich ganz und nenne dich Freund,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nder du mein Herr bist. "), _c('a', {
    attrs: {
      "id": "page5",
      "title": "JohannN/wedi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0